import type { Optional } from '@festina-life/core'
import { paperStyles } from '@festina-life/ui/libs'
import { Typography } from '@festina-life/ui/structure'

type Props = {
  title?: Optional<string>
}

export const FPlusOverflownCodeIndicator = ({ title }: Props) => (
  <div
    data-testid="overflowIndicator"
    className="relative flex w-full flex-col gap-y-2 px-1"
  >
    <div className="w-full border-b-2 border-solid border-slate-400 dark:border-slate-600" />
    <div className="w-1/4 border-b-2 border-solid border-slate-400 dark:border-slate-600" />
    <div className="w-1/2 border-b-2 border-solid border-slate-400 dark:border-slate-600" />
    <div className="w-full border-b-2 border-solid border-slate-400 dark:border-slate-600" />
    {title && (
      <Typography
        intensity="tertiary"
        className={`absolute left-4 top-1/2 -translate-y-1/2 pr-1 ${paperStyles({ isFaded: false })}`}
      >
        {title}
      </Typography>
    )}
  </div>
)
